// extracted by mini-css-extract-plugin
export default {"shareButtons":"ShareButtons_shareButtons__oyRdP"};